import React from "react";
import useNearViewport from "../../utils/useNearViewport";

export default function DeferredShelf({ eager, children }) {
  const [ref, ready] = useNearViewport({ eager });
  return (
    <div ref={ref} className={ready ? undefined : "cinema-deferred-shelf"}>
      {ready ? (
        children
      ) : (
        <div aria-hidden="true" className="cinema-deferred-placeholder" />
      )}
    </div>
  );
}
